<template>
  <div data-page="form">

    <tabs-component :form="form" ref="tabs" />

    <div class="form-pages">
      <section-component v-for="page, index in form.json" :id="index + 1" ref="sectionRefs" @updatePercentageComplete="updatePercentageComplete" />
    </div>

    <div ref="nav" class="form-nav">
      <div class="program-nav">
        <div class="button-wrapper">
          <div id="sync-assessment">
            <div id="sync-assessment-active" data-css-scope="quasar">
              <QSpinner
                  color="primary"
                  size="20px"
                  :thickness="4"
              />
            </div>
            <div id="sync-assessment-done" data-css-scope="quasar">
              <QIcon name="cloud_done" size="24px"></QIcon>
            </div>
          </div>
          <div class="active-program button">
            <div class="select-wrapper button-indicator" v-if="submissions.length > 1">
              <select v-model="submissionId" @change="onProgramSelected($event)">
                <option v-for="aSubmission in submissions" :value="aSubmission.id">{{ aSubmission.name }}</option>
              </select>
            </div>
            <div class="button-label">{{ submission.name }}</div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" v-if="submissions.length > 1">
              <path d="M8.95,9.05L7.5,7.6L12,3.1l4.5,4.5l-1.45,1.45L12,6L8.95,9.05z M12,21l-4.5-4.5l1.45-1.45L12,18.1l3.05-3.05l1.45,1.45L12,21z"/>
            </svg>
          </div>
        </div>

        <div class="button-wrapper">
          <router-link class="button" :to="`/${$i18n.locale}/overview?id=${submission.id}&active=${id}`">
            <div class="button-indicator"></div>
            <div class="button-label">{{$t('overview')}}</div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path d="M12,4c3.87,0,6.67,0,7.34,0.66C20,5.33,20,8.13,20,12s0,6.67-0.66,7.34C18.67,20,15.87,20,12,20s-6.67,0-7.34-0.66C4,18.67,4,15.87,4,12s0-6.67,0.66-7.34C5.33,4,8.13,4,12,4 M12,2C2,2,2,2,2,12s0,10,10,10s10,0,10-10S22,2,12,2L12,2z M17.75,8c0-0.55-0.45-1-1-1h-6c-0.55,0-1,0.45-1,1s0.45,1,1,1h6C17.3,9,17.75,8.55,17.75,8z M17.75,12c0-0.55-0.45-1-1-1h-6c-0.55,0-1,0.45-1,1s0.45,1,1,1h6C17.3,13,17.75,12.55,17.75,12z M17.75,16c0-0.55-0.45-1-1-1h-6c-0.55,0-1,0.45-1,1s0.45,1,1,1h6C17.3,17,17.75,16.55,17.75,16z M7.5,6.75C6.81,6.75,6.25,7.31,6.25,8S6.81,9.25,7.5,9.25S8.75,8.69,8.75,8S8.19,6.75,7.5,6.75zM7.5,10.75c-0.69,0-1.25,0.56-1.25,1.25s0.56,1.25,1.25,1.25S8.75,12.69,8.75,12S8.19,10.75,7.5,10.75z M7.5,14.75c-0.69,0-1.25,0.56-1.25,1.25c0,0.69,0.56,1.25,1.25,1.25S8.75,16.69,8.75,16C8.75,15.31,8.19,14.75,7.5,14.75z"/>
            </svg>
          </router-link>
          <a class="button" @click="print()">
            <div class="button-indicator"></div>
            <div class="button-label">{{ $t('print') }}</div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path d="M16,8V5H8v3H6V3h12v5H16z M4,10c0,0,0.1,0,0.29,0c0.19,0,0.43,0,0.71,0h14c0.28,0,0.52,0,0.71,0C19.9,10,20,10,20,10h-2H6H4z M18,12.5c0.28,0,0.52-0.1,0.71-0.29C18.9,12.02,19,11.78,19,11.5s-0.1-0.52-0.29-0.71C18.52,10.6,18.28,10.5,18,10.5s-0.52,0.1-0.71,0.29C17.1,10.98,17,11.22,17,11.5s0.1,0.52,0.29,0.71C17.48,12.4,17.72,12.5,18,12.5z M16,19v-4H8v4H16z M18,21H6v-4H2v-6c0-0.85,0.29-1.56,0.88-2.14C3.46,8.29,4.17,8,5,8h14c0.85,0,1.56,0.29,2.14,0.86C21.71,9.44,22,10.15,22,11v6h-4V21zM20,15v-4c0-0.28-0.1-0.52-0.29-0.71C19.52,10.1,19.28,10,19,10H5c-0.28,0-0.52,0.1-0.71,0.29C4.1,10.48,4,10.72,4,11v4h2v-2h12v2H20z"/>
            </svg>
          </a>
        </div>
      </div>
      <div class="progress">

        <div class="progress-group">
          <div class="progress-group-meta">
            <span class="progress-group-name">
              Principle: {{ currentPageName.get() }}
            </span>
            <span class="progress-group-percent">{{ pagePercentComplete }}%&nbsp;{{ $t('percent-complete') }}</span>
          </div>
          <div class="progress-bar-track" :style="`--progress: ${pagePercentComplete}`">
            <div class="progress-bar-bar">
              <div class="progress-bar-gradient"></div>
            </div>
          </div>
        </div>

        <div class="progress-group">
          <div class="progress-group-meta">
            <span class="progress-group-name">
              {{ $t('full-assessment') }}
            </span>
            <span class="progress-group-percent">{{ percentComplete }}%&nbsp;{{ $t('percent-complete') }}</span>
          </div>
          <div class="progress-bar-track" :style="`--progress: ${percentComplete}`">
            <div class="progress-bar-bar">
              <div class="progress-bar-gradient"></div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="print-only">
      <section-component v-for="page, index in form.json" :id="index + 1" ref="sectionRefs" :print="true" />
    </div>

  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, provide, computed, nextTick, onBeforeUnmount } from 'vue';
import { onBeforeRouteUpdate, useRoute } from 'vue-router';
import QualityMentoringForm from './models/QualityMentoringForm';
import SectionComponent from './components/SectionComponent.vue';
import TabsComponent from './components/TabsComponent.vue';
import Manager from '../../core/Manager';

enum Transitions {
  SlideInLeft = 'v-enter-active slide-in-left',
  SlideOutLeft = 'v-leave-active slide-out-left',
  SlideInRight = 'v-enter-active slide-in-right',
  SlideOutRight = 'v-leave-active slide-out-right',
}

const form = ref(QualityMentoringForm.getInstance());
provide('form', QualityMentoringForm.getInstance());
const sectionRefs = ref([]);
const submission = ref(Manager.getInstance().submission)
const submissions = ref(Manager.getInstance().submissions.list);
const submissionId = ref(submission.value.id);
const route = useRoute();
declare const API_URL: any;
const id = ref(useRoute().params.id);
const pagePercentComplete = ref(0);
const percentComplete = ref(0);
const tabs = ref();
const nav = ref();

const currentPageName = computed(() => {
  return form.value.pages[parseInt(id.value as string) - 1].name;
});

QualityMentoringForm.getInstance().updateMetrics(Manager.getInstance().submission);

onMounted(async () => {
  document.fonts.ready.then(() => {
    tabs.value.updateTabs(id.value);
  });
  window.addEventListener('resize', onResize);
  document.body.classList.remove('loading');
  await nextTick();
  onResize();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
  document.documentElement.style.removeProperty('--form-nav-height');
});

onBeforeRouteUpdate((to, from) => {
  // @ts-ignore
  const toIndex = parseInt(to.params.id) - 1;
  // @ts-ignore
  const fromIndex = parseInt(from.params.id) - 1;

  const slideLeft = toIndex > fromIndex;

  const leaving = sectionRefs.value[fromIndex];
  const entering = sectionRefs.value[toIndex];

  if (slideLeft) {
    entering.transitionEnterClass = Transitions.SlideInLeft;
    leaving.transitionLeaveClass = Transitions.SlideOutLeft;
  } else {
    entering.transitionEnterClass = Transitions.SlideInRight;
    leaving.transitionLeaveClass = Transitions.SlideOutRight;
  }

  id.value = to.params.id;
  const page = QualityMentoringForm.getInstance().pages[parseInt(id.value as string) - 1]
  pagePercentComplete.value = page.percentComplete;

  tabs.value.updateTabs(to.params.id);
});

const onResize = () => {
  const el = nav.value;
  const height = el.offsetHeight;
  document.documentElement.style.setProperty('--form-nav-height', `${height}px`);
}

const updatePercentageComplete = function(pageId, percent) {
  if (pageId != id.value) {
    return;
  }
  pagePercentComplete.value = percent;
  percentComplete.value = QualityMentoringForm.getInstance().percentComplete;
}

function print() {
  window.print();
}

function onProgramSelected() {
  const redirect = `${route.path}?id=${submissionId.value}`;
  window.location.href = redirect;
}
</script>
